/*
 * CLAIM-SUMMARY-CARD.JSX - Claim Summary Information Display Component
 * 
 * SUMMARY:
 * A comprehensive summary card component that displays detailed financial breakdowns
 * for project claims and retention information. Used to show aggregated financial
 * data in an organized, readable format.
 */

import React from 'react'
import { toUSD } from 'src/util/currency-formatter'

const ClaimSummaryCard = ({ title, summaryItems, ...props }) => {
  return (
    <div className='summary-section' {...props}>
      <h4 className='section-title'>{title}</h4>
      <div className="summary-content">
        {summaryItems.map((item, index) => (
          <div className="summary-item" key={index}>
            <span className="label">{item.label}:</span>
            <span className="value" data-cy={`${item.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}-value`}>
              {toUSD(item.value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ClaimSummaryCard